import { render, staticRenderFns } from "./NftList.vue?vue&type=template&id=3a445f6a&"
import script from "./NftList.vue?vue&type=script&lang=ts&"
export * from "./NftList.vue?vue&type=script&lang=ts&"
import style0 from "./NftList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports